import { RestApiKey } from 'graphql/generated/graphqlTypes';
import { restApiKeysVar } from 'state/vars';

export const setRestApiKeysAction = (apiKeys: RestApiKey[]) => {
  restApiKeysVar(apiKeys);
};

export const updateRestApiKeyAction = (updatedRestApiKey: RestApiKey) => {
  const currentRestApiKey = restApiKeysVar();
  const updatedRestApiKeys = currentRestApiKey.map((restApiKey) =>
    restApiKey.id === updatedRestApiKey.id ? updatedRestApiKey : restApiKey
  );

  restApiKeysVar(updatedRestApiKeys);
};

export const deleteRestApiKeyAction = (deletedRestApiKeyId: string) => {
  const currentRestApiKey = restApiKeysVar();
  const updatedRestApiKeys = currentRestApiKey.filter((restApiKey) => restApiKey.id !== deletedRestApiKeyId);

  restApiKeysVar(updatedRestApiKeys);
};
